<template>
    <div class="preset-item">
        <span @click="applyPreset()">{{ stripTimestampAndExtension(preset.name) }}</span>
        <v-progress-circular v-if="processing" class="mr-2" color="var(--color-accent)" indeterminate size="16" width="3" />
        <v-btn @click="exportPreset()"
               class="btn-export-preset"
               v-tippy="{ placement: 'top', boundary: 'window' }"
               content="Export Preset"
               :disabled="processing"
        >
            <v-icon size="18" class="material-icons">save_alt</v-icon>
        </v-btn>
        <v-btn @click="deletePreset()"
               class="btn-delete-preset"
               v-tippy="{ placement: 'top', boundary: 'window' }"
               content="Delete Preset"
               :disabled="processing"
        >
            <v-icon size="18" class="material-icons">highlight_off</v-icon>
        </v-btn>
    </div>
</template>

<script>
import FilenameMixin from "@/mixins/Filename";
import SparkMD5 from "spark-md5";

export default {
    mixins: [FilenameMixin],
    data() {
        return {
            processing: false,
        }
    },
    props: {
        preset: Object
    },
    methods: {
        async applyPreset() {
            if (this.processing) return;
            this.$store.dispatch("Loader/showProgressBar", "indeterminate");
            window.UI.disableBlockAddingButtons();

            this.processing = true;

            let presetData = await window.lutify.fetchPreset(this.preset.id);
            await window.lutify.applyPreset(presetData);

            this.processing = false;

            if (window.lutify.selectedIDT && !window.lutify.selectedIDT.initial) {
                window.UI.enableImageTools(true);
                window.UI.enableODT();
            }

            this.$store.dispatch("Loader/showProgressBar", false);
            window.UI.hideModal();
        },
        async deletePreset() {
            if (this.processing) return;
            this.$store.dispatch("UserFiles/selectPreset", this.preset);
            window.UI.hideModal();
            window.UI.showModal(window.UI.modals.presets.delete.el);
        },
        async exportPreset() {
            if (this.processing) return;
            this.processing = true;

            let blocks = await window.lutify.fetchPreset(this.preset.id);

            let data = {
                author: this.$store.state.User.name,
                name: this.stripTimestampAndExtension(this.preset.name),
                dateOfCreation: new Date().toISOString().slice(0, 10),
                md5: SparkMD5.hash(JSON.stringify(blocks)),
                blocks,
            };

            data = JSON.stringify(data, null, "\t");

            let element = document.createElement("a");
            element.setAttribute("href", "data:application/json;charset=utf-8," + encodeURIComponent(data));
            element.setAttribute("download", `${this.stripTimestampAndExtension(this.preset.name)}.json` || "exported-preset.json");
            element.style.display = "none";
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);

            this.processing = false;
        },
    }
}
</script>

<style lang="scss" scoped>
.preset-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 4px 2px 8px;
    border-radius: 5px;

    //&:not(:last-of-type) {
    //    margin-bottom: 7px;
    //}

    &:hover {
        transition: all 0.05s ease-in;
        background: rgb(54, 54, 54);
        cursor: pointer;
    }

    > span {
        flex: 1;
        padding-right: 7px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 1rem;
        color: var(--font-default-color);
    }

    ::v-deep .v-btn {
        min-width: auto;
        height: auto;
        box-shadow: none;
        background-color: transparent;
        color: var(--font-default-color);
        padding: 3px;

        &--active {
            &::before {
                background-color: var(--color-accent);
                opacity: 0.4;
            }
        }

        &--disabled,
        &--disabled .v-icon {
            background-color: transparent !important;
            color: var(--font-default-color) !important;
            opacity: 0.4;
        }
    }
}
</style>